import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'r-widget-control',
  templateUrl: './r-widget-control.component.html',
  styles: [],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class RWidgetControlComponent implements OnInit {
  @Input() control?;
  constructor() {}

  ngOnInit() {}
}
